import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import arraySort from 'array-sort'
import { injectIntl } from 'react-intl'
import Select from 'react-select'

import SearchArea from '../mini/SearchArea'
import CourseSelect from '../mini/CourseSelect'
import WrappedSearchFilter from '../HOC/WrappedSearchFilter'

import { fetchProductionStatusCounts } from '../../actions/productionstatus'
import {
  setAuthorsFilter,
  setTagFilters,
  setPrimarySubjectFilter,
  setAssignedToFilters,
  setTargetGradeLevelFilter,
  setCourseFilter,
  setLevelFilter as setLevelFilterAction
} from '../../actions/productionstatusfilters'
import { messages as labels } from '../../utils/messages/label'
import { messages as placeholders } from '../../utils/messages/placeholder'
import { getqdUsers, assignedUsers } from '../../selectors/users'
import { courseLevels } from '../../selectors/courselevels'
import { mapLevels } from '../../utils/levels'

class SearchFilters extends Component {
  constructor (props) {
    super(props)
    this.onSearchClickBound = this.onSearchClick.bind(this)
    this.courseFilterRef = React.createRef()
    this.levelFilterRef = React.createRef()
    this.onSetCourseFilterBound = this.onSetCourseFilter.bind(this)
    this.setLevelFilterBound = this.setLevelFilter.bind(this)
  }

  render () {
    const {
      dispatch,
      isFetchingUsers,
      tags,
      isFetchingTags,
      authorFilters,
      tagFilters,
      primarySubjectFilters,
      isFetchingSubjects,
      primarySubjects,
      assignedToFilters,
      qdUsers,
      assignedUsers,
      gradeLevels,
      isFetchingGrades,
      gradeFilters,
      intl,
      courses,
      courseFilter,
      levelFilters,
      levels
    } = this.props

    const labelMessages = {
      author: intl.formatMessage(labels.author),
      tags: intl.formatMessage(labels.tags),
      primarySubject: intl.formatMessage(labels.primarySubject),
      assignedTo: intl.formatMessage(labels.assignedTo),
      status: intl.formatMessage(labels.status),
      targetGradeLevel: intl.formatMessage(labels.targetGradeLevel)
    }

    const placeholderMessages = {
      selectAuthors: intl.formatMessage(placeholders.selectAuthors),
      selectTags: intl.formatMessage(placeholders.selectTags),
      selectSubject: intl.formatMessage(placeholders.selectSubject),
      selectColleagues: intl.formatMessage(placeholders.selectColleagues),
      selectGrades: intl.formatMessage(placeholders.selectGrades)
    }

    return (
      <div className="quests-search">
        <div className="filter-by-container">
          <div className="caption1 filter-by-caption">Filter by</div>
          <div className="area inputs-wrapper">
            <SearchArea
              headerClass="h5"
              dispatch={dispatch}
              label={labelMessages.author}
              area="author"
              placeholder={placeholderMessages.selectAuthors}
              values={authorFilters}
              options={arraySort(this.mapList(qdUsers), ['sort'])}
              filterAction={setAuthorsFilter}
              loading={isFetchingUsers}
              fetchAction={fetchProductionStatusCounts}
            />

            <SearchArea
              headerClass="h5"
              dispatch={dispatch}
              label={labelMessages.assignedTo}
              area="assigned-to"
              placeholder={placeholderMessages.selectColleagues}
              values={assignedToFilters}
              options={arraySort(this.mapList(assignedUsers), ['sort'])}
              filterAction={setAssignedToFilters}
              loading={isFetchingUsers}
              fetchAction={fetchProductionStatusCounts}
            />

            <SearchArea
              headerClass="h5"
              dispatch={dispatch}
              label={labelMessages.tags}
              area="tags"
              placeholder={placeholderMessages.selectTags}
              values={tagFilters}
              options={arraySort(this.mapList(tags), ['sort'])}
              filterAction={setTagFilters}
              loading={isFetchingTags}
              fetchAction={fetchProductionStatusCounts}
            />

            <SearchArea
              headerClass="h5"
              dispatch={dispatch}
              label={labelMessages.primarySubject}
              area="subjects"
              placeholder={placeholderMessages.selectSubject}
              values={primarySubjectFilters}
              options={arraySort(this.mapList(primarySubjects), ['sort'])}
              filterAction={setPrimarySubjectFilter}
              loading={isFetchingSubjects}
              fetchAction={fetchProductionStatusCounts}
            />

            <SearchArea
              headerClass="h5"
              dispatch={dispatch}
              label={labelMessages.targetGradeLevel}
              area="grades"
              placeholder={placeholderMessages.selectGrades}
              values={gradeFilters}
              options={arraySort(this.mapList(gradeLevels), ['sort'])}
              filterAction={setTargetGradeLevelFilter}
              loading={isFetchingGrades}
              fetchAction={fetchProductionStatusCounts}
            />

            {courses.length > 0 && (
              <WrappedSearchFilter
                area="courses"
                active={Boolean(this.props.courseFilter)}
                label="Intended Journey"
                wrappedRef={this.courseFilterRef}
              >
                <CourseSelect
                  courseFilterRef={this.courseFilterRef}
                  course={courseFilter ? courseFilter : null}
                  courses={courses}
                  onCourseChange={this.onSetCourseFilterBound}
                  labelTruncationLength={99999}
                  placeholder="Select journey"
                />
              </WrappedSearchFilter>
            )}
            {courseFilter && (
              <WrappedSearchFilter
                area="levels"
                active={this.props.levelFilters.length > 0}
                disabled={levels.length === 0}
                disabledText="No levels are available for this journey."
                label="Intended Level"
                wrappedRef={this.levelFilterRef}
              >
                <Select
                  multi
                  ref={this.levelFilterRef}
                  searchable
                  options={mapLevels(levels, 22)}
                  value={levelFilters}
                  onChange={this.setLevelFilterBound}
                  placeholder="Select level"
                  matchProp="label"
                />
              </WrappedSearchFilter>
            )}
          </div>
        </div>
      </div>
    )
  }

  onSearchClick () {
    this.props.dispatch(fetchProductionStatusCounts(1, true))
  }

  // TODO: similar method in other components. use a util
  mapList (arr) {
    return arr.map(function (el) {
      return {
        value: el.id,
        label: el.name,
        sort: el.sort ? el.sort : el.name.trim().toLowerCase()
      }
    })
  }

  async onSetCourseFilter (e) {
    await this.props.dispatch(setCourseFilter(e ? e : null))
    this.onSearchClickBound()
  }

  async setLevelFilter (event) {
    this.props.dispatch(
      setLevelFilterAction(
        event.map(function (e) {
          return e.value
        })
      )
    )
    this.props.dispatch(this.onSearchClickBound)
  }
}

SearchFilters.propTypes = {
  dispatch: PropTypes.func,
  qdUsers: PropTypes.array.isRequired,
  assignedUsers: PropTypes.array.isRequired,
  isFetchingUsers: PropTypes.bool,
  tags: PropTypes.array.isRequired,
  isFetchingTags: PropTypes.bool,
  authorFilters: PropTypes.array,
  tagFilters: PropTypes.array,
  statusFilters: PropTypes.array,
  primarySubjectFilters: PropTypes.array,
  primarySubjects: PropTypes.array,
  isFetchingSubjects: PropTypes.bool,
  assignedToFilters: PropTypes.array,
  gradeLevels: PropTypes.array,
  isFetchingGrades: PropTypes.bool,
  gradeFilters: PropTypes.array,
  intl: PropTypes.object.isRequired,
  courses: PropTypes.array,
  courseFilter: PropTypes.object,
  levelFilters: PropTypes.array,
  levels: PropTypes.array
}

export const mapStateToProps = state => ({
  users: state.users.items,
  qdUsers: getqdUsers(state),
  assignedUsers: assignedUsers(state),
  isFetchingUsers: state.users.isFetching,
  tags: state.tags.items,
  isFetchingTags: state.tags.isFetching,
  authorFilters: state.productionstatusfilters.authors_id_in || [],
  tagFilters: state.productionstatusfilters.questtags_id_in || [],
  draftFilterSelected:
    state.productionstatusfilters.reviewing_compiled_quest_state_null !== null,
  primarySubjects: state.subjects.items,
  primarySubjectFilters:
    state.productionstatusfilters.quest_subject_id_in || [],
  isFetchingSubjects: state.subjects.isFetching,
  assignedToFilters: state.productionstatusfilters.assigned_to_id_in,
  gradeLevels: state.gradelevels.items,
  isFetchingGrades: state.gradelevels.isFetching,
  gradeFilters: state.productionstatusfilters.grade_levels_id_in,
  courses: state.mockcourses.items,
  courseFilter: state.productionstatusfilters.mock_course_id_in || null,
  levelFilters: state.productionstatusfilters.mock_level_id_in || [],
  levels: courseLevels(state, state.productionstatusfilters.mock_course_id_in)
})

export default injectIntl(connect(mapStateToProps)(SearchFilters))
export { SearchFilters as SearchFiltersDisconnected } // pure component - for tests



// WEBPACK FOOTER //
// ./src/components/productionstatus/SearchFilters.js